// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export interface NonStreamingOrderByResult {
  orderByItems: [];
  payload: any;
}
